import { cva } from 'class-variance-authority';

import type { DetailedHTMLProps, HTMLAttributes, PropsWithChildren } from 'react';

import s from './TextCut.module.css';

const textCutVariants = cva(s.textCut, {
  variants: {
    multiline: {
      true: s['textCut--multiline'],
    },
  },
});

type TextCutProps = Omit<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'children' | 'style'> &
  PropsWithChildren<{
    /**
     * Number of lines to display
     * @default 1
     */
    linesCount?: number;
  }>;

/**
 * Component to cut long text strings with ellipsis
 */
export const TextCut = ({ children, className, linesCount = 1, ...props }: TextCutProps) => {
  const multiline = linesCount > 1;

  return (
    <div
      style={{
        ...(multiline && { WebkitLineClamp: linesCount }),
      }}
      className={textCutVariants({ className, multiline })}
      {...props}
    >
      {children}
    </div>
  );
};
